export default __webpack_public_path__ + "static/media/ARG.f79ee67a.svg";